import { render, staticRenderFns } from "./changePeople.vue?vue&type=template&id=3fd9e086&scoped=true&"
import script from "./changePeople.vue?vue&type=script&lang=js&"
export * from "./changePeople.vue?vue&type=script&lang=js&"
import style0 from "./changePeople.vue?vue&type=style&index=0&id=3fd9e086&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd9e086",
  null
  
)

export default component.exports